module.exports = __webpack_public_path__ + "img/SES_40_38_061_360.777b6533.jpg";